import { render, staticRenderFns } from "./ValidPhone.vue?vue&type=template&id=5206c6fe&scoped=true"
import script from "./ValidPhone.vue?vue&type=script&lang=js"
export * from "./ValidPhone.vue?vue&type=script&lang=js"
import style0 from "./ValidPhone.vue?vue&type=style&index=0&id=5206c6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206c6fe",
  null
  
)

export default component.exports